/**
 * Set up popups
 */
const popup = (opt) => {

	// grab each popup wrapper individually
	const popWrap = document.querySelectorAll(opt.selectors.wrap);
	if(popWrap){
		popWrap.forEach((pop) => {

			// grab the elements
			const triggerEl = pop.querySelectorAll(opt.selectors.trigger);
			const popupEl = pop.querySelectorAll(opt.selectors.popup);
			const contentEl = pop.querySelectorAll(opt.selectors.content);
			const closeEl = [];
			const amount = popupEl.length;

			// handle animations
			const ani = (index, opening) => {
				const pos = triggerEl[index].getBoundingClientRect();
				if(opening) {
					Object.assign(popupEl[index].style, {
						top: `${pos.top}px`,
						left: `${pos.left}px`,
						width: `${pos.width}px`,
						height: `${pos.height}px`,
					});
					setTimeout(() => {
						Object.assign(popupEl[index].style, {
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
						});
					}, 10);
				} else {
					Object.assign(popupEl[index].style, {
						top: `${pos.top}px`,
						left: `${pos.left}px`,
						width: `${pos.width}px`,
						height: `${pos.height}px`,
					});
				}
			}

			// control popup open
			const open = (e, index) => {
				e.preventDefault(); // in case there's an href for some reason
				ani(index, true);
				popupEl[index].setAttribute('aria-hidden', false);
				closeEl[index].focus();
				opt.lock && (document.body.style.overflow = 'hidden');
			};

			// control popup close
			const close = (index) => {
				ani(index, false);
				popupEl[index].setAttribute('aria-hidden', true);
				opt.lock && (document.body.style.overflow = null);
			};

			// initialize the popup
			// note: for this to work requires identical number(s) of triggers/popup
			for(let i = 0; i < amount; i++) {
				// add accessibility features
				contentEl[i].setAttribute('tabindex', 0);
				popupEl[i].setAttribute('aria-modal', true);
				// add a close button
				const closeButton = document.createElement('button');
				closeButton.classList.add('popup-close', 'button--basic');
				closeButton.setAttribute('aria-label', 'close');
				closeButton.addEventListener('click', () => close(i));
				closeButton.textContent = 'Close';
				closeEl.push(closeButton);
				const closeButtonWrap = document.createElement('div');// the only reasons this is here is to position the close button...
				closeButtonWrap.classList.add('popup-frame');
				closeButtonWrap.prepend(closeButton);
				contentEl[i].parentNode.insertBefore(closeButtonWrap, contentEl[i]);
				closeButtonWrap.appendChild(contentEl[i]);
				// setup to open popup on trigger click
				triggerEl[i].addEventListener('click', (e) => open(e, i));
				// move/identify the popup outside parent to bottom of page (to avoid any overflow issues)
				document.body.appendChild(popupEl[i]);
				popupEl[i].classList.add('popup-wrap')
			}

		});
	}

}

export default popup;

